import { styled } from '@mui/material/styles';

import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from '../Header/headerConstants';

export const StyledLayoutMain = styled('main', {
  shouldForwardProp: (prop) => prop !== 'withoutHeaderPadding',
})<{ withoutHeaderPadding?: boolean }>(({ theme, withoutHeaderPadding }) => ({
  [theme.breakpoints.up('sm')]: {
    paddingTop: withoutHeaderPadding ? 48 : HEADER_HEIGHT_DESKTOP + 48,
    paddingBottom: theme.spacing(12),
    paddingLeft: theme.spacing(25),
    paddingRight: theme.spacing(25),
    width: '100%',
    maxWidth: '1440px',
    margin: '0 auto',
  },
  paddingTop: withoutHeaderPadding ? 48 : HEADER_HEIGHT_MOBILE + 48,
  paddingBottom: HEADER_HEIGHT_MOBILE + 48,
  paddingLeft: theme.spacing(4),
  width: '100%',
  paddingRight: theme.spacing(4),
}));
